<template>
  <b-row class="mb-3 mt-3">
    <b-col cols="12" v-html="data.content"></b-col>
  </b-row>
</template>

<script>
export default {
  name: "pre-tabla",
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          index: null,
          tag: "Tabla",
          content: ">_<"
        };
      }
    }
  },
  created(){
      console.log(this.data.content);
  }
};
</script>
<style lang="css" scoped>
table{
    width: 100% !important;
}
</style>